var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMovieQueuedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.536,
    height: 20.536,
    viewBox: "0 0 20.536 20.536",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "schedule_FILL0_wght400_GRAD0_opsz48",
    d: "M17.5,18.657a.739.739,0,0,0,.539.231.785.785,0,0,0,.565-.257.861.861,0,0,0,.27-.59.693.693,0,0,0-.244-.565L15.115,13.96V9.545a.717.717,0,0,0-.218-.526.77.77,0,0,0-1.322.552v4.7a.754.754,0,0,0,.051.282,1.021,1.021,0,0,0,.154.257Zm-3.234,5.878a9.935,9.935,0,0,1-3.979-.809,10.345,10.345,0,0,1-5.48-5.48,10.193,10.193,0,0,1,0-7.958,10.345,10.345,0,0,1,5.48-5.48,10.193,10.193,0,0,1,7.958,0,10.345,10.345,0,0,1,5.48,5.48,10.193,10.193,0,0,1,0,7.958,10.345,10.345,0,0,1-5.48,5.48A9.935,9.935,0,0,1,14.268,24.536ZM14.268,14.268Zm0,8.728a8.4,8.4,0,0,0,6.161-2.567A8.4,8.4,0,0,0,23,14.268a8.4,8.4,0,0,0-2.567-6.161A8.4,8.4,0,0,0,14.268,5.54,8.4,8.4,0,0,0,8.107,8.107,8.4,8.4,0,0,0,5.54,14.268a8.4,8.4,0,0,0,2.567,6.161A8.4,8.4,0,0,0,14.268,23Z",
    transform: "translate(-4 -4)",
    fill: "#aeb1b4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovieQueuedIcon);
export default __webpack_public_path__ + "static/media/MovieQueuedIcon.e27c3dfd01e4325bb305d6015cce728d.svg";
export { ForwardRef as ReactComponent };